import { createFileRoute } from "@tanstack/react-router";
import SharedConversation from "@/pages/SharedConversation";

export const Route = createFileRoute("/shared/$token")({
  component: SharedConversation,
});
